import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { TagsModel, TagsServerModel } from '@domain/entities/tags.model';

export abstract class TagsGateway {
    abstract read(params?: HttpParams): Observable<TagsServerModel[]>;
    abstract create(form: TagsModel): Observable<TagsServerModel>;
    abstract readById(id: number): Observable<TagsServerModel>;
    abstract update(id: number, form: TagsModel): Observable<TagsServerModel>;
    abstract delete(id: number): Observable<TagsServerModel>;
}
